<template>
  <div>
    <template v-for="lang in languages">
      <div :key="lang" @click="setLocale(lang)">
        <slot :label="$t('locale.' + lang)" :active="locale === lang" />
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'App',
  data() {
    return {
      languages: ['fr_FR', 'en_EN'],
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      moment.locale(locale.substr(0, 2))
    },
  },
}
</script>
